module.exports = __webpack_public_path__ + "img/Delivery-At-Premises.87a9c773.jpg";